import React, { useState } from 'react';

import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useActivateAutoMining } from 'api/autoMiningApi';
import { ModalBg } from 'assets/images';

import CustomModal from '../CustomModal';

import './UseDiamondModal.scss';

const UseDiamondModal = ({ show, onClose, pairId }) => {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);

  const activateMutation = useActivateAutoMining();

  const handleDecrement = () => setCount((prev) => Math.max(0, prev - 1));
  const handleIncrement = () => setCount((prev) => prev + 1);

  const handleClose = () => {
    setCount(0);
    onClose();
  };

  const handleApply = () => {
    if (count === 0) return;
    activateMutation.mutate({ days: count, pairId }, {
      onSuccess: () => {
        setCount(0);
        onClose();
        setShowSuccess(true);
      },
      onError: (error) => {
        setErrorMessage(error?.response?.data?.message || t('useDiamondModal.errorFallback'));
        onClose();
        setShowError(true);
      },
    });
  };

  return (
    <>
      <Modal
        backdrop="static"
        centered
        className="use-diamond-modal"
        keyboard={false}
        onHide={handleClose}
        show={show}
      >
        <div className="udm-bg" style={{ backgroundImage: `url(${ModalBg})` }}>
          <div className="udm-inner">
            <h4 className="udm-title">{t('useDiamondModal.title')}</h4>
            <p className="udm-subtitle">{t('useDiamondModal.subtitle')}</p>

            <div className="udm-counter">
              <button className="udm-counter-btn" onClick={handleDecrement} type="button">
                -
              </button>
              <span className="udm-counter-value">{count}</span>
              <button className="udm-counter-btn" onClick={handleIncrement} type="button">
                +
              </button>
            </div>

            <p className="udm-info">{t('useDiamondModal.diamondHoursInfo', { count, hours: count * 24 })}</p>

            <div className="udm-actions">
              <button className="udm-btn udm-btn--cancel" onClick={handleClose} type="button">
                {t('useDiamondModal.cancel')}
              </button>
              <button
                className="udm-btn udm-btn--apply"
                disabled={count === 0 || activateMutation.isPending}
                onClick={handleApply}
                type="button"
              >
                {activateMutation.isPending ? t('useDiamondModal.applying') : t('useDiamondModal.applyDiamond')}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <CustomModal
        onClose={() => setShowSuccess(false)}
        show={showSuccess}
        title={t('useDiamondModal.successMessage')}
      />

      <CustomModal
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
        show={showError}
        title={errorMessage}
      />
    </>
  );
};

export default UseDiamondModal;
